import { connect } from 'react-redux';

import ZeroPresentationModalContent from '@xanadu/ui-shared/components/MBZeroInfoPanel/ZeroPresentationModalContent';

function mapStateToProps(state) {
  return {
    videoId: state.getIn(['application', 'mbZeroConfig', 'widgetVideoId']),
  };
}

export default connect(mapStateToProps, null)(ZeroPresentationModalContent);
